import { render, staticRenderFns } from "./subscribe-bi.vue?vue&type=template&id=43584372&"
import script from "./subscribe-bi.vue?vue&type=script&lang=js&"
export * from "./subscribe-bi.vue?vue&type=script&lang=js&"
import style0 from "./subscribe-bi.vue?vue&type=style&index=0&id=43584372&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports